var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-divider"),
      _c(
        "v-sheet",
        {
          staticClass:
            "\n      pa-2\n      pb-0\n      max-width\n      d-flex\n      flex-nowrap\n      align-center\n      justify-space-between\n    ",
          class: _vm.dense ? "pt-0" : "",
        },
        [
          _c("span", { staticClass: "text-caption text--secondary" }, [
            _vm._v(
              " " +
                _vm._s(_vm.other) +
                " " +
                _vm._s(
                  _vm.$t("label_essweb_list_components_pagenations_columnLabel")
                ) +
                "(" +
                _vm._s(
                  _vm.$t("label_essweb_list_components_pagenations_totalLabel")
                ) +
                " " +
                _vm._s(_vm.length) +
                " " +
                _vm._s(
                  _vm.$t("label_essweb_list_components_pagenations_columnLabel")
                ) +
                ") "
            ),
          ]),
          _c("v-spacer"),
          _c("v-pagination", {
            staticClass:
              "text--primary d-inline-block text-truncate text-center",
            attrs: {
              disabled: _vm.isLoading || _vm.localLoading,
              color: "grey lighten-2 ",
              "prev-icon": "navigate_before",
              "next-icon": "navigate_next",
              length: Math.ceil(
                _vm.length /
                  (_vm.options.pagination.itemsPerPage == -1
                    ? _vm.length
                    : _vm.options.pagination.itemsPerPage)
              ),
              "total-visible": 7,
            },
            on: {
              input: function () {
                if (_vm.isLoading || _vm.localLoading) {
                  return
                }
              },
            },
            model: {
              value: _vm.page,
              callback: function ($$v) {
                _vm.page = $$v
              },
              expression: "page",
            },
          }),
          _vm.showItemPages ? _c("v-spacer") : _vm._e(),
          _vm.showItemPages
            ? _c("span", { staticClass: "text-caption text--secondary pr-1" }, [
                _vm._v(_vm._s(_vm.options.itemsPerPageText)),
              ])
            : _vm._e(),
          _vm.showItemPages
            ? _c(
                "v-menu",
                {
                  attrs: { "offset-y": "", small: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  staticClass:
                                    "\n            mrc-border-solid\n            text-capitalize\n            pa-0\n            white\n            text-body-2\n            d-flex\n            justify-space-around\n          ",
                                  staticStyle: {
                                    "border-color":
                                      "rgba(0, 0, 0, 0.1) !important",
                                    "border-radius": "6px",
                                    "min-width": "60px",
                                  },
                                  attrs: {
                                    width: "60",
                                    height: "28",
                                    outlined: "",
                                    depressed: "",
                                    "x-small": "",
                                    text: "",
                                  },
                                },
                                on
                              ),
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.options.pagination.itemsPerPage == -1
                                        ? _vm.$t(
                                            "label_essweb_list_components_pagenations_selectNumber_allLabel"
                                          )
                                        : _vm.options.pagination.itemsPerPage
                                    ) +
                                    " "
                                ),
                                _c(
                                  "i",
                                  { staticClass: "material-icons-round" },
                                  [_vm._v("arrow_drop_down")]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1490756588
                  ),
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(
                      _vm.options.itemsPerPageOptions,
                      function (item, index) {
                        return _c(
                          "v-list-item",
                          {
                            key: index,
                            on: {
                              click: function ($event) {
                                _vm.perpage = item
                              },
                            },
                          },
                          [
                            _c("v-list-item-title", [
                              _vm._v(
                                _vm._s(
                                  item == -1
                                    ? _vm.$t(
                                        "label_essweb_list_components_pagenations_selectNumber_allLabel"
                                      )
                                    : item
                                )
                              ),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }